import { render, staticRenderFns } from "./IconInfo.vue?vue&type=template&id=12a2df78&scoped=true"
var script = {}
import style0 from "./IconInfo.vue?vue&type=style&index=0&id=12a2df78&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "12a2df78",
  null
  
)

export default component.exports